import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface OnboardingState {
  run: boolean;
  stepIndex: number;
  isNavigating: boolean;
  startTour: () => void;
  stopTour: () => void;
  resetTour: () => void;
  resetOnboardingStore: () => void;
  setStepIndex: (index: number) => void;
  setIsNavigating: (isNavigating: boolean) => void;
}

export const useOnboardingStore = create<OnboardingState>()(
  immer(set => ({
    run: false, // Default to false - will be set to true only if needed
    stepIndex: 0,
    isNavigating: false,
    startTour: () =>
      set(state => {
        state.run = true;
        state.stepIndex = 0;
        state.isNavigating = false;
      }),
    stopTour: () =>
      set(state => {
        state.run = false;
      }),
    resetTour: () =>
      set(state => {
        state.run = true;
        state.stepIndex = 0;
        state.isNavigating = false;
      }),
    resetOnboardingStore: () =>
      set(state => {
        state.run = false;
        state.stepIndex = 0;
        state.isNavigating = false;
      }),
    setStepIndex: (index: number) =>
      set(state => {
        state.stepIndex = index;
      }),
    setIsNavigating: (isNavigating: boolean) =>
      set(state => {
        state.isNavigating = isNavigating;
      }),
  })),
);
